// Cards endpoint
export const GET_DASHBOARD_CARDS = 'GET_DASHBOARD_CARDS';
export const GET_DASHBOARD_CARDS_SUCCESS = 'GET_DASHBOARD_CARDS_SUCCESS';
export const GET_DASHBOARD_CARDS_FAILED = 'GET_DASHBOARD_CARDS_FAILED';

// Charts endpoint
export const GET_DASHBOARD_CHARTS = 'GET_DASHBOARD_CHARTS';
export const GET_DASHBOARD_CHARTS_SUCCESS = 'GET_DASHBOARD_CHARTS_SUCCESS';
export const GET_DASHBOARD_CHARTS_FAILED = 'GET_DASHBOARD_CHARTS_FAILED';

// Recent controls endpoint
export const GET_DASHBOARD_RECENT_CONTROLS = 'GET_DASHBOARD_RECENT_CONTROLS';
export const GET_DASHBOARD_RECENT_CONTROLS_SUCCESS = 'GET_DASHBOARD_RECENT_CONTROLS_SUCCESS';
export const GET_DASHBOARD_RECENT_CONTROLS_FAILED = 'GET_DASHBOARD_RECENT_CONTROLS_FAILED';